module.exports = __webpack_public_path__ + "img/hr-burner-inserter-hand-base.e512b107.png";